import React from 'react';

import DetailPageHeader from '../components/detail-page-header';

function SettingsContainer(): React.ReactElement {
  return <DetailPageHeader title="Settings" />;
}

export default SettingsContainer;
